import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import './i18n/i18n';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Header from './components/Header';
import Footer from './components/Footer';
import { useFirebaseAuth } from './hooks/useFirebaseAuth';
import { useFcm } from './hooks/useFcm';

function RequireAuth({ authUid, user, loading }) {
  const location = useLocation();
  if (!authUid) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }
  if (loading || !user) {
    return (
      <div className="haydi-loading" role="status" aria-live="polite">
        <div className="haydi-loading__spinner" />
        <span className="haydi-loading__text">…</span>
      </div>
    );
  }
  return <Outlet />;
}

function App() {
  const {
    user,
    loading,
    authUid,
    authInitialized,
    refreshUser,
    login,
    logout,
  } = useFirebaseAuth();

  useFcm(user);

  const handleLogin = () => {
    window.location.href = '/';
  };

  if (!authInitialized) {
    return (
      <div className="haydi-loading" role="status" aria-live="polite">
        <div className="haydi-loading__spinner" />
        <span className="haydi-loading__text">…</span>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Header
        user={user}
        authUid={authUid}
        onLogout={logout}
        onLogin={handleLogin}
      />
      <div className="haydi-app-main">
        <Routes>
          <Route
            path="/"
            element={authUid ? <Navigate to="/dashboard/profile" replace /> : <Login login={login} />}
          />
          <Route element={<RequireAuth authUid={authUid} user={user} loading={loading} />}>
            <Route path="/dashboard/*" element={<Dashboard user={user} refreshUser={refreshUser} />} />
          </Route>
        </Routes>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
